module.exports = __webpack_public_path__ + "img/Wagon_Side_Right.00be059b.svg";